export enum ConfirmationModalResponse {
  CANCEL = 'cancel',
  CONFIRM = 'confirm',
}
